import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as blueprint from '@adc/blueprint'
import {
  OnboardingDrawer,
  TutorialTooltipActions,
  useApplicationContext,
  hooks,
} from '@adc/ui-adc'
import { hooks as experimentHooks, getExperimentFlags } from '@adc/experiments'
import { useModalFeatures } from '../hooks/useModalFeatures'

const OnboardingDrawerContainer = props => {
  const { toggleAuthModal } = useModalFeatures()
  const { experiments, embeddedContext } = useApplicationContext()
  const onboardingExperiments = [
    'ed203-newvisitslider_modallink',
    'ed-199-new_visitor_slider_time_to_get_started',
  ]
  const getABExperiments = (experimentsList, experiments) => {
    const experimentFlags = getExperimentFlags(experiments)
    return experimentsList.reduce((acc, experiment) => {
      return {
        ...acc,
        [experiment]: experimentHooks.useFeatureFlag(
          experimentFlags?.[experiment]
        ),
      }
    }, {})
  }
  const { useIsMobileHook } = hooks
  const isMobile = useIsMobileHook()

  if (embeddedContext === 'webview') return null

  const getStarted = () => toggleAuthModal('signup')
  return (
    <OnboardingDrawer
      getStarted={getStarted}
      isSmartSale={
        props.listing
          ? blueprint.listing.utils.isSmartSale(props.listing)
          : false
      }
      {...props}
      experiments={getABExperiments(onboardingExperiments, experiments)}
      isMobile={isMobile}
    />
  )
}

OnboardingDrawerContainer.propTypes = {
  elmId: PropTypes.string,
  featureFlags: PropTypes.object,
  listing: PropTypes.object,
}

const mapStateToProps = store => ({
  user: store.user,
})

const mapDispatchToProps = dispatch => ({
  startTour: () => dispatch(TutorialTooltipActions.incrementTutorial()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingDrawerContainer)
